import React from 'react'

import Button from 'components/Form/Button'
import { buildS3DownloadUrl } from 'services/s3Download'
import { parseStrapiImage } from 'utils'
import { Icon } from 'ui/styled'
import { trackEvent } from 'services/analytics'

import {
  CardRoot,
  EmptyText,
  PreviewFrame,
  PreviewImage,
  ResourceAction,
  ResourceItem,
  ResourceList,
  ResourceMeta,
  ResourceTitle,
  ResourceTitleRow,
  ResourceType,
  SectionMeta,
  SectionTitle,
} from './styled'

const triggerFileDownload = resource => {
  const fileUrl = typeof resource?.file === 'string'
    ? resource.file
    : resource?.file?.url
      ? parseStrapiImage(resource.file.url)
      : null
  if (!fileUrl) return

  trackEvent('FILE_DOWNLOAD', {
    content_type: 'course-resource',
    content_id: resource?.id,
    resource_id: resource?.file?.id || resource?.id,
    content_name: resource?.title || resource?.file?.name,
  })
  window.location.href = buildS3DownloadUrl({
    sourceUrl: fileUrl,
    filename: resource?.file || resource?.title || 'resource',
  })
}

export default function CourseDetailsResourcesCard({
  title = 'Resources',
  subtitle,
  resources,
  lesson,
  embedded = false,
  emptyText = 'No resources available for this lesson yet.',
}) {
  const previewImage = lesson?.image?.url ? parseStrapiImage(lesson.image.url) : lesson?.cover

  return (
    <CardRoot embedded={embedded}>
      {!title ? null : <SectionTitle>{title}</SectionTitle>}
      {!subtitle ? null : <SectionMeta>{subtitle}</SectionMeta>}

      {embedded || !previewImage ? null : (
        <PreviewFrame>
          <PreviewImage alt={lesson?.title || title} src={previewImage} />
        </PreviewFrame>
      )}

      {resources?.length ? (
        <ResourceList>
          {resources.map(resource => (
            <ResourceItem key={resource?.id}>
              <ResourceTitleRow>
                <ResourceType>
                  <Icon icon={resource?.type === 'file' ? 'download' : 'eye'} />
                </ResourceType>
                <div>
                  <ResourceTitle>{resource?.title}</ResourceTitle>
                  <ResourceMeta>{resource?.description}</ResourceMeta>
                </div>
              </ResourceTitleRow>

              <ResourceAction>
                {resource?.type !== 'file' ? (
                  <Button
                    color="blue"
                    nospace
                    onClick={() => {
                      trackEvent('EXTERNAL_LINK_CLICK', {
                        content_type: 'course-resource',
                        content_id: resource?.id,
                        content_name: resource?.title,
                      })
                      window.open(resource?.url, '_blank', 'noopener,noreferrer')
                    }}
                    width="fit-content"
                  >
                    Open
                  </Button>
                ) : (
                  <Button color="blue" nospace onClick={() => triggerFileDownload(resource)} width="fit-content">
                    Download
                  </Button>
                )}
              </ResourceAction>
            </ResourceItem>
          ))}
        </ResourceList>
      ) : (
        <EmptyText>{emptyText}</EmptyText>
      )}
    </CardRoot>
  )
}
